import AbstractComponentController from '../../../core/abstracts/controllers/component-controller';
import showCheckInModalTemplate from './show-checkin-modal.tpl.html';
import Checkins from '../../../../store/checkins';

export default class AlRsvpCheckinsComponentController extends AbstractComponentController {

    constructor($scope, $injector, $element) {
        super($scope, $injector, $element);

        this.uibModal = this.injector.get('$uibModal');
        this.alert = this.injector.get('Alert');
    }

    $onInit() {
        this.loadCheckins();
    }

    loadCheckins() {
        this.store = new Checkins(this.injector.get('Checkin'), {injector: this.injector});

        this.store.commit('setPermanentFilters', {'rsvp.id': this.rsvp.id});
        this.store.commit('setVisible', ['rsvp.pax_planned', 'rsvp.pax_actual', 'pax_new', 'pax_old', 'location']);

        this.store.commit('addAction', {
            key: 'details',
            text: 'Details',
            level: 'row',
            class: 'btn green',
            action: this.showCheckin
        });

        this.store.commit('addAction', {
            key: 'show_archived',
            title: 'Show archived',
            level: 'settings',
            manager: 'showArchived'
        });

        this.store.commit('setVm', this);
    }


    showCheckin(payload, store) {
        this.uibModal.open({
            animation: true,
            size: 'lg',
            templateUrl: showCheckInModalTemplate,
            controller: ['checkin', '$uibModalInstance', function (checkin, $uibModalInstance) {
                this.checkin = checkin;
                this.close = function () {
                    $uibModalInstance.dismiss();
                }
            }],
            controllerAs: 'vm',
            resolve: {
                checkin: () => {
                    return store.state.model
                        .one(payload.row.id)
                        .get({include: 'guestlist,contact,parent,children,parent.contact,children.contact'})
                        .then(null, () => {
                            this.alert.error('Checkin not found');
                        });
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/rsvps/components/al-rsvp-checkins/controller.js